import { Component } from 'react';
import styled from 'styled-components';
import Isotope from 'isotope-layout';
import ReactDOM from 'react-dom';
import 'isotope-packery';
import 'isotope-cells-by-row';
import { meta } from '../../meta';

export class ItemGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { isotope: null };
  }

  componentDidMount() {
    const { options } = this.props;
    const node = ReactDOM.findDOMNode(this);

    this.setState({
      isotope: new Isotope(node, options),
      updateTimeout: null
    });
  }

  componentDidUpdate() {
    if (this.state.isotope) {
      const { options } = this.props;

      clearTimeout(this.state.updateTimeout);

      // oxlint-disable-next-line react/no-direct-mutation-state
      this.state.updateTimeout = setTimeout(() => {
        this.state.isotope.reloadItems();
        this.state.isotope.arrange(options);
      }, 500);
    }
  }

  render() {
    return <Grid>{this.props.children}</Grid>;
  }
}

const Grid = styled.div.attrs({
  className: `${meta.stylePrefix}-item-grid-component`
})`
  transition: 0.3s ease all;
`;
